module.exports = __webpack_public_path__ + "static/officers_min-1afa8cafe76fab9074aa3e50d5418dd4.jpg";